<button type="button" class="btn btn-info-outline" [class.btn-sm]="sm" (click)="back()">
    <clr-icon shape="undo"></clr-icon>
    Back
</button>